import React from 'react';
import {findEventDayEntity} from '../calendar/calendar-context';
import {withTranslation} from "react-i18next";

const eventDay = (props) => {
  let selectedDayEntity = findEventDayEntity(props.date);

  let title = selectedDayEntity?.fieldEventTitle;
  let body = selectedDayEntity?.body?.value;
  if (props.i18n.language === 'en') {
    title = selectedDayEntity?.fieldEventTitleEn;
    body = selectedDayEntity?.bodyEn?.value;
  }

  let markUp = "";

  if (Object.keys(selectedDayEntity).length > 0) {
    markUp =
      <div className="container py-3">
        <div className="row">
          <div className="col-lg-12">
            <div className="event text-center">
              <strong className="h3">{title}</strong>
              <span className="text-stretched" dangerouslySetInnerHTML={{__html: body}} />
            </div>
          </div>
        </div>
      </div>;
  }

  return markUp;
}

export default withTranslation()(eventDay)
